import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bond-duration-calculator',
  component: () => import('../../routes/BondDurationCalculator.svelte'),
  card: {
    id: 'bond-duration-calculator',
    title: 'Bond Duration Calculator',
    description: 'Calculate Macaulay and Modified Duration for bonds. Understand price sensitivity to interest rate changes.',
    icon: 'schedule',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/bond-duration-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Bond Duration Calculator – Macaulay & Modified Duration',
    description: 'Free bond duration calculator. Calculate Macaulay Duration, Modified Duration, and DV01 to measure bond price sensitivity to interest rate changes. Essential for fixed income investors.',
  },
};

export default meta;